import { render } from "./ButtonCopyToClipboard.vue?vue&type=template&id=e67f0ad4"
import script from "./ButtonCopyToClipboard.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCopyToClipboard.vue?vue&type=script&setup=true&lang=js"

import "./ButtonCopyToClipboard.vue?vue&type=style&index=0&id=e67f0ad4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Moleculas/ButtonCopyToClipboard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e67f0ad4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e67f0ad4', __exports__)) {
    api.reload('e67f0ad4', __exports__)
  }
  
  module.hot.accept("./ButtonCopyToClipboard.vue?vue&type=template&id=e67f0ad4", () => {
    api.rerender('e67f0ad4', render)
  })

}


export default __exports__